const coberturaCompletaAction = {
  CC_POLIZA_EXTRACT: "CC_POLIZA_EXTRACT",
  CC_POLIZA_EXTRACT_ASEGURADORA: "CC_POLIZA_EXTRACT_ASEGURADORA",
  CC_POLIZA_SEGUNDA_PAGINA: "CC_POLIZA_SEGUNDA_PAGINA",
  CC_POLIZA_SEGUNDA_PAGINA_DONE: "CC_POLIZA_SEGUNDA_PAGINA_DONE",
  CC_POLIZA_ERROR: "CC_POLIZA_ERROR",
  CC_RES_QUOTE: "CC_RES_QUOTE",
  CC_ADD_QUOTE: "CC_ADD_QUOTE",
  CC_DEDUCIBLE: "CC_DEDUCIBLE",
  CC_RES_QUOTE_LIMITE2: "CC_RES_QUOTE_LIMITE2",
  CC_ADD_QUOTE_LIMITE2: "CC_ADD_QUOTE_LIMITE2",
  CC_RES_QUOTE_LIMITE3: "CC_RES_QUOTE_LIMITE3",
  CC_ADD_QUOTE_LIMITE3: "CC_ADD_QUOTE_LIMITE3",
  CC_SELECT_SEGURO: "CC_SELECT_SEGURO",
  CC_QUOTES_CATEGORY_INTERCOM: "CC_QUOTES_CATEGORY_INTERCOM",
  CC_QUOTE_SELECTED_INTERCOM: "CC_QUOTE_SELECTED_INTERCOM",
  CC_NO_POLIZA: "CC_NO_POLIZA",
  CC_CARRO_VIEJO: "CC_CARRO_VIEJO",
  SHOW_SPIN_FORM_CC: "SHOW_SPIN_FORM_CC",
  CYBER_FORM_COMPLETED_CC: "CYBER_FORM_COMPLETED_CC",
  CYBER_POST_RESPONSE_CC: "CYBER_POST_RESPONSE_CC",
  EMISION_RESPONSE_CC: "EMISION_RESPONSE_CC",
  EMISION_ERROR_MESSAGE_CC: "EMISION_ERROR_MESSAGE_CC",
  CYBER_FORM_DATA_CC: "CYBER_FORM_DATA_CC",
  CC_SET_QUOTES_REFERRAL: "CC_SET_QUOTES_REFERRAL",
  CC_SET_QUOTE_ID: "CC_SET_QUOTE_ID",
  CC_SET_DATA_USER: "CC_SET_DATA_USER",
  CC_SET_INSPECTION_ID: "CC_SET_INSPECTION_ID",

  coberturaCompletaSetDataUser: valor => {
    return (dispatch) => {
      const cc_data_user = valor;
      dispatch({
        type: coberturaCompletaAction.CC_SET_DATA_USER,
        cc_data_user
      });
    };
  },

  coberturaCompletaExtractPoliza: valor => {
    return (dispatch) => {
      const cc_poliza_datos = valor;
      dispatch({
        type: coberturaCompletaAction.CC_POLIZA_EXTRACT,
        cc_poliza_datos
      });
    };
  },
  coberturaCompletaExtractAseguradora: valor => {
    return (dispatch) => {
      const cc_poliza_aseguradora = valor;
      dispatch({
        type: coberturaCompletaAction.CC_POLIZA_EXTRACT_ASEGURADORA,
        cc_poliza_aseguradora
      });
    };
  },
  coberturaCompletaSegundaPagina: valor => {
    return (dispatch) => {
      const cc_poliza_segundaPagina = valor;
      dispatch({
        type: coberturaCompletaAction.CC_POLIZA_SEGUNDA_PAGINA,
        cc_poliza_segundaPagina
      });
    };
  },
  coberturaCompletaSegundaPaginaDone: valor => {
    return (dispatch) => {
      const cc_poliza_segundaPagina_done = valor;
      dispatch({
        type: coberturaCompletaAction.CC_POLIZA_SEGUNDA_PAGINA_DONE,
        cc_poliza_segundaPagina_done
      });
    };
  },
  coberturaCompletaError: valor => {
    return (dispatch) => {
      const cc_poliza_error = valor;
      dispatch({
        type: coberturaCompletaAction.CC_POLIZA_ERROR,
        cc_poliza_error
      });
    };
  },
  resetQuoteCoberturaCompleta: valor => {
    return (dispatch) => {
      const cc_quotes = valor;
      dispatch({
        type: coberturaCompletaAction.CC_RES_QUOTE,
        cc_quotes
      });
    };
  },
  addQuoteCoberturaCompleta: valor => {
    return (dispatch) => {
      const cc_quotes = valor;
      dispatch({
        type: coberturaCompletaAction.CC_ADD_QUOTE,
        cc_quotes
      });
    };
  },
  resetQuoteCoberturaCompletaLimite2: valor => {
    return (dispatch) => {
      const cc_quotes_limite2 = valor;
      dispatch({
        type: coberturaCompletaAction.CC_RES_QUOTE_LIMITE2,
        cc_quotes_limite2
      });
    };
  },
  addQuoteCoberturaCompletaLimite2: valor => {
    return (dispatch) => {
      const cc_quotes_limite2 = valor;
      dispatch({
        type: coberturaCompletaAction.CC_ADD_QUOTE_LIMITE2,
        cc_quotes_limite2
      });
    };
  },
  resetQuoteCoberturaCompletaLimite3: valor => {
    return (dispatch) => {
      const cc_quotes_limite3 = valor;
      dispatch({
        type: coberturaCompletaAction.CC_RES_QUOTE_LIMITE3,
        cc_quotes_limite3
      });
    };
  },
  addQuoteCoberturaCompletaLimite3: valor => {
    return (dispatch) => {
      const cc_quotes_limite3 = valor;
      dispatch({
        type: coberturaCompletaAction.CC_ADD_QUOTE_LIMITE3,
        cc_quotes_limite3
      });
    };
  },
  coberturaCompletaEscogerDeducible: valor => {
    return (dispatch) => {
      const cc_deducible = valor;
      dispatch({
        type: coberturaCompletaAction.CC_DEDUCIBLE,
        cc_deducible
      });
    };
  },
  coberturaCompletaEscogerSeguro: valor => {
    return (dispatch) => {
      const seguroSeleccionado = valor;
      dispatch({
        type: coberturaCompletaAction.CC_SELECT_SEGURO,
        seguroSeleccionado
      });
    };
  },
  coberturaCompletaNoPoliza: valor => {
    return (dispatch) => {
      const noPoliza = valor;
      dispatch({
        type: coberturaCompletaAction.CC_NO_POLIZA,
        noPoliza
      });
    };
  },
  carroMasSieteAnos: valor => {
    return (dispatch) => {
      const carroViejo = valor;
      dispatch({
        type: coberturaCompletaAction.CC_CARRO_VIEJO,
        carroViejo
      });
    };
  },
  showSpinFormCC: show_spin_form_cc => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.SHOW_SPIN_FORM_CC,
        show_spin_form_cc
      });
    };
  },
  setCyberFormCompletedCC: cyber_form_completed_cc => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.CYBER_FORM_COMPLETED_CC,
        cyber_form_completed_cc
      });
    };
  },
  setCyberFormDataCC: cyber_form_data_cc => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.CYBER_FORM_DATA_CC,
        cyber_form_data_cc
      });
    };
  },
  setCyberPostResponseCC: cyber_post_response_cc => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.CYBER_POST_RESPONSE_CC,
        cyber_post_response_cc
      });
    };
  },
  setEmisionResponseCC: emision_response_cc => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.EMISION_RESPONSE_CC,
        emision_response_cc
      });
    };
  },
  setEmisionErrorMessageCC: emision_error_message_cc => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.EMISION_ERROR_MESSAGE_CC,
        emision_error_message_cc
      });
    };
  },
  setQuotesCategoryCC: cc_quotes_category_intercom => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.CC_QUOTES_CATEGORY_INTERCOM,
        cc_quotes_category_intercom
      })
    }
  },
  setQuoteSelectedIntercom: cc_quote_selected_intercom => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.CC_QUOTE_SELECTED_INTERCOM,
        cc_quote_selected_intercom
      })
    }
  },
  setCCQuotesReferral: cc_quotes_referral => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.CC_SET_QUOTES_REFERRAL,
        cc_quotes_referral
      })
    }
  },
  setCCQuoteId : cc_quote_id => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.CC_SET_QUOTE_ID,
        cc_quote_id,
      })
    }
  },
  setInspectionId: inspectionId => {
    return dispatch => {
      dispatch({
        type: coberturaCompletaAction.CC_SET_INSPECTION_ID,
        inspectionId
      })
    }
  }
};

export default coberturaCompletaAction;
